import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {ConfirmationModalWindow} from '../confirmation-modal-window/ConfirmationModalWindow';
import {FormattedDate, useIntl} from 'react-intl';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import {
  editSearchDialogue,
  removeSearchDialogue,
  searchAsyncActions
} from '../../redux/pageAsyncActions';
import {ISearchDialogue} from '../../redux/search/interfaces';
import SearchModalWindow from '../search-modal-window';

import './styles.scss';

type Props = {
  card: ISearchDialogue;
  onClick: () => void;
}

export const SearchCard = ({
  card,
  onClick
}: Props): JSX.Element => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [cardData, setCardData] = useState<ISearchDialogue>(card);
  const [isShowEditDialogue, setShowEditDialogue] = useState<boolean>(false);
  const [isShowDeleteDialogue, setShowDeleteDialogue] = useState<boolean>(false);

  function handleOpenEditDialogueModal() {
    setShowEditDialogue(true);
  }

  useEffect(() => {
    setCardData(card);
  }, [card]);

  function handleEditDialogue(dialogue: ISearchDialogue) {
    dispatch(searchAsyncActions[editSearchDialogue](dialogue));
    setCardData(dialogue);
    setShowEditDialogue(false);
  }

  function handleDeleteDialogue() {
    dispatch(searchAsyncActions[removeSearchDialogue](cardData));
  }

  function handleCloseDialogue() {
    setShowEditDialogue(false);
  }

  function handleOpenDeleteDialogue() {
    setShowDeleteDialogue(true);
  }

  function handleCloseDeleteDialogue() {
    setShowDeleteDialogue(false);
  }

  function handleClick() {
    onClick();
  }

  function renderBasicCard() {
    return <div className="search-area">
      <div className="search-area__card-place">
        <div className="search-area__card">
          <div className="search-area__title">
            <div className="search-area__title-wrapper">
              <button className="search-area__title__text" onClick={handleClick}>{cardData.dialogName}</button>
              <div className="search-area__title__date">{cardData.dialogUserDate != null
                && <FormattedDate
                  value={cardData.dialogUserDate}
                  year="numeric"
                  month="long"
                  hour="numeric"
                  minute="numeric"
                  day="2-digit"
                />}</div>
            </div>
          </div>
          <div className="search-area__title-percent" style={{
            background: `linear-gradient(to left, #f2f2f2 ${100 - cardData.percentage}%, #EBA378 ${100 - cardData.percentage}%)`
          }}>
          </div>
        </div>
        <div className="search-area__bottom">
          <div className="search-area__btn">
            <GritxButton
              title={intl.formatMessage({
                id: 'gritx.search.card.rename',
                defaultMessage: 'Rename'
              })}
              variant={ButtonVariant.Outline}
              disabled={false}
              className="search-area__button"
              onClick={handleOpenEditDialogueModal}
            />
          </div>
          <div className="search-area__btn">
            <GritxButton
              title={intl.formatMessage({
                id: 'gritx.search.card.delete',
                defaultMessage: 'Delete'
              })}
              variant={ButtonVariant.Outline}
              disabled={cardData.percentage === 100}
              className="search-area__button"
              onClick={handleOpenDeleteDialogue}
            />
          </div>
        </div>
      </div>
      <SearchModalWindow
        dialogueCard={card}
        title={intl.formatMessage({
          id: 'gritx.search.card.title.edit',
          defaultMessage: 'Edit the search'
        })}
        onSave={handleEditDialogue}
        onClose={handleCloseDialogue}
        show={isShowEditDialogue}
      />
      <ConfirmationModalWindow
        title={intl.formatMessage({
          id: 'gritx.search.card.delete.confirmation',
          defaultMessage: 'Are you sure you want to delete the search?'
        })}
        onSave={handleDeleteDialogue}
        onClose={handleCloseDeleteDialogue}
        show={isShowDeleteDialogue}
      />
    </div>;
  }

  return renderBasicCard();
};
